import React from "react";
//#region types
import { ProjectMemberStatusTagsProps } from "models/propTypes/timeReportingProjectPropTypes";
import { Tags } from "components/common";
import { ProjectMember } from "models/formTypes/timeReportingProject";
import { TranslationKeys } from "translations";

//#endregion
//#region components
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const ProjectMemberStatusTags: React.FC<ProjectMemberStatusTagsProps> = (props) => {
  const { member } = props;
  const getLabelClass = (member: ProjectMember) => {
    return member.isTimeReportingActive ? cssExports.greenTag : cssExports.grayTag;
  };

  const getLabel = (member: ProjectMember) => {
    return member.isTimeReportingActive
      ? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReportingProject.ProjectMemberIsActive)
      : LocalizationHelperInstance.getFormattedMessage(TranslationKeys.TimeReportingProject.ProjectMemberIsInActive);
  };

  return <Tags tags={[getLabel(member)]} className={getLabelClass(member)} />;
};

export default ProjectMemberStatusTags;
